/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ line: NonNullable<unknown> }} Event_Style_Summary_Position_OtherInputs */

const en_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Line ${i?.line}`)
};

const fr_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ligne ${i?.line}`)
};

const de_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeile ${i?.line}`)
};

const it_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linea ${i?.line}`)
};

const ru_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Линия ${i?.line}`)
};

const es_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Línea ${i?.line}`)
};

const zh_cn2_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`线 ${i?.line}`)
};

const ja_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ライン ${i?.line}`)
};

const hi_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लाइन ${i?.line}`)
};

const pt_pt2_event_style_summary_position_other = /** @type {(inputs: Event_Style_Summary_Position_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linha ${i?.line}`)
};

/**
* | output |
* | --- |
* | "Line {line}" |
*
* @param {Event_Style_Summary_Position_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_position_other = /** @type {((inputs: Event_Style_Summary_Position_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Position_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_style_summary_position_other(inputs)
	if (locale === "de") return de_event_style_summary_position_other(inputs)
	if (locale === "it") return it_event_style_summary_position_other(inputs)
	if (locale === "ru") return ru_event_style_summary_position_other(inputs)
	if (locale === "es") return es_event_style_summary_position_other(inputs)
	if (locale === "zh-CN") return zh_cn2_event_style_summary_position_other(inputs)
	if (locale === "ja") return ja_event_style_summary_position_other(inputs)
	if (locale === "hi") return hi_event_style_summary_position_other(inputs)
	if (locale === "pt-PT") return pt_pt2_event_style_summary_position_other(inputs)
	return en_event_style_summary_position_other(inputs)
});